namespace TabAurous.OMS {
    export interface CollectionMasterRow {
        AttributeId?: number;
        AttributeTypeId?: number;
        AttributeCode?: string;
        AttributeName?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace CollectionMasterRow {
        export const idProperty = 'AttributeId';
        export const nameProperty = 'AttributeCode';
        export const localTextPrefix = 'OMS.CollectionMaster';
        export const lookupKey = 'OMS.CollectionMaster';

        export function getLookup(): Q.Lookup<CollectionMasterRow> {
            return Q.getLookup<CollectionMasterRow>('OMS.CollectionMaster');
        }
        export const deletePermission = 'Product:Collection:Delete';
        export const insertPermission = 'Product:Collection:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:Collection:Edit';

        export declare const enum Fields {
            AttributeId = "AttributeId",
            AttributeTypeId = "AttributeTypeId",
            AttributeCode = "AttributeCode",
            AttributeName = "AttributeName",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
